import loadable from '@loadable/component';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Spinner from '../../components/Reusable/Spinner';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';
//@ts-ignore
import { usePDFPrintHook } from '@careinfo/layout';
const EditOrderComponent = loadable(
  () => import('../../components/Consignment/EditConsignment')
);
const EditConsignment = () => {
  const { id } = useParams();
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [selectedConsignment, setSelectedConsignment] = useState(null);
  const [searchParams, setSearchParms] = useSearchParams();

  const { data: OrderData, isLoading: isGettingData } = useGetHook({
    queryKey: [`order-${id}`],
    url: `${APIS.ORDER}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ['order'],
    navigateURL: '',
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}${id}/`;
    const formatContact = (number) => {
      if (!number) return null;
      return number.startsWith('+977') ? number : `+977${number}`;
    };

    let formData = {
      ...values,
      receiver_phone_number: formatContact(values?.receiver_phone_number),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        setOpenPrintPopup(true);
        setSelectedConsignment(id);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handleLabelPrintDownload = async () => {
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedConsignment],
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete('selectedItems');
      setSearchParms(searchParams);
    } catch (err) {
      console.log(err);
    }
  };

  const handleConsignmentReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedConsignment],
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete('selectedItems');
      setSearchParms(searchParams);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isGettingData ? (
        <Spinner />
      ) : (
        <EditOrderComponent
          OrderData={OrderData}
          handleEdit={handleEdit}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          handleLabelPrintDownload={handleLabelPrintDownload}
          isPrintLoading={isPrintLoading}
          handleConsignmentReceiptDownload={handleConsignmentReceiptDownload}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default EditConsignment;
